export enum SeniorityLevel {
  INTERN = 'Student/Intern',
  JUNIOR = 'Junior',
  MID_LEVEL = 'Mid-level',
  SENIOR = 'Senior',
  EXECUTIVE = 'Executive',
}
